module.exports = __webpack_public_path__ + "img/banner_01.43a7cba6.png";